import { PluginKey, Plugin, TextSelection } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

class CustomTextSelection extends TextSelection {
}
const DragHandlePluginKey = new PluginKey("DragHandle");
const DragHandlePlugin = () => {
  const handleTransactions = (transactions, oldState, newState) => {
    const uiDropTransaction = transactions.find((tr) => tr.getMeta("uiEvent") === "drop");
    if (uiDropTransaction && oldState.selection instanceof CustomTextSelection && !(newState.selection instanceof CustomTextSelection)) {
      const tr = newState.tr;
      const resolved = newState.doc.resolve(tr.selection.head);
      tr.setSelection(TextSelection.create(newState.doc, resolved.end()));
      return tr;
    }
    return null;
  };
  return new Plugin({
    key: DragHandlePluginKey,
    appendTransaction: handleTransactions,
    // Add state management for decorations
    state: {
      init() {
        return DecorationSet.empty;
      },
      apply(tr, oldSet) {
        const newSet = oldSet.map(tr.mapping, tr.doc);
        if (tr.selectionSet) {
          if (tr.selection instanceof CustomTextSelection) {
            const { $from, $to } = tr.selection;
            const decorations = [];
            tr.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
              if (node.isBlock && pos >= $from.pos - 1 && pos <= $to.pos) {
                decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                  class: "ProseMirror-draghandle-selected"
                }));
                return false;
              }
              return true;
            });
            return DecorationSet.create(tr.doc, decorations);
          }
          return DecorationSet.empty;
        }
        return newSet;
      }
    },
    // Provide decorations to the view
    props: {
      decorations(state) {
        return this.getState(state);
      }
    }
  });
};

export { CustomTextSelection, DragHandlePlugin, DragHandlePluginKey };
//# sourceMappingURL=dragHandlePlugin.js.map
